"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _mapKeys = _interopRequireDefault(require("lodash/mapKeys"));
var _commonCta = require("@mmc/common-cta");
var _text = require("@mmc/text");
var _offersV = require("./offers-v3.prop-types");
var _offerCard = _interopRequireDefault(require("./offer-card.css"));
var _offersV2 = require("./offers-v3.utils");
var OfferCard = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  function OfferCard() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  (0, _inheritsLoose2["default"])(OfferCard, _React$PureComponent);
  var _proto = OfferCard.prototype;
  _proto.ctaClickHandler = function ctaClickHandler() {
    var _this$props = this.props,
      offer = _this$props.offer,
      vehicleName = _this$props.vehicleName;
    localStorage.setItem('offerClicked', "" + offer.offerCode + (vehicleName ? "|" + vehicleName : ''));
  };
  _proto.renderDownPayment = function renderDownPayment(downPaymentLabel, exampleDownPayment) {
    if (downPaymentLabel && exampleDownPayment) {
      return downPaymentLabel.replace('{exampleDownPayment}', exampleDownPayment);
    }
    return '';
  };
  _proto.render = function render() {
    var _clsx, _descriptionsMap$subH;
    var _this$props2 = this.props,
      className = _this$props2.className,
      offer = _this$props2.offer,
      vehicleName = _this$props2.vehicleName,
      theme = _this$props2.theme,
      offerFilter = _this$props2.offerFilter,
      offerLabel = _this$props2.offerLabel,
      buildAndPriceUrl = _this$props2.buildAndPriceUrl,
      showActionButton = _this$props2.showActionButton;
    var descriptionsMap = (0, _mapKeys["default"])(offer.descriptions, 'type');
    var isFirstColAvailable = offer.title && offer.subTitle;
    var isInventoryBtnAvailable = (offerLabel == null ? void 0 : offerLabel.inventoryLabel) && (offerLabel == null ? void 0 : offerLabel.inventoryRedirectionURL);
    var ctaCount = isInventoryBtnAvailable && showActionButton ? 2 : isInventoryBtnAvailable || showActionButton ? 1 : 0;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_offerCard["default"].offerCardContainer, className),
      "data-ctalength": ctaCount
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "summary"
    }, descriptionsMap.subHeadline && /*#__PURE__*/_react["default"].createElement("p", {
      className: "title"
    }, descriptionsMap.subHeadline.text), ((0, _offersV2.isOfferType)(offer, 'finance') || (0, _offersV2.isOfferType)(offer, 'lease')) && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_offerCard["default"].offerGrid, (_clsx = {}, _clsx[_offerCard["default"].isFirstColAvailable] = isFirstColAvailable, _clsx))
    }, isFirstColAvailable && /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _offerCard["default"].gridItem
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _offerCard["default"].gridSubtitle
    }, offer.offerType)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _offerCard["default"].gridItem
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _offerCard["default"].gridSubtitle
    }, isFirstColAvailable && (offerLabel == null ? void 0 : offerLabel.atLabel), !isFirstColAvailable && (offerLabel == null ? void 0 : offerLabel.rateStartAtLabel))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _offerCard["default"].gridItem
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _offerCard["default"].gridSubtitle
    }, offerLabel == null ? void 0 : offerLabel.forLabel)), isFirstColAvailable && /*#__PURE__*/_react["default"].createElement("div", {
      className: _offerCard["default"].gridItem + " " + _offerCard["default"].gridItemMiddle
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _offerCard["default"].gridMainTitle
    }, offer.title)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _offerCard["default"].gridItem + " " + _offerCard["default"].gridItemMiddle
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _offerCard["default"].gridMainTitle
    }, offer.rate)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _offerCard["default"].gridItem + " " + _offerCard["default"].gridItemMiddle
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _offerCard["default"].gridMainTitle
    }, offer.exampleTermLength)), isFirstColAvailable && /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _offerCard["default"].gridItem
    }, offer.subTitle && /*#__PURE__*/_react["default"].createElement("div", {
      className: _offerCard["default"].gridSubtitle
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: "" + offer.subTitle,
      tag: "p",
      disclaimerData: offer.disclaimerData
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _offerCard["default"].gridItem
    }, (offer == null ? void 0 : offer.exampleDownPayment) && /*#__PURE__*/_react["default"].createElement("div", {
      className: _offerCard["default"].gridSubtitle
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: this.renderDownPayment(offerFilter == null ? void 0 : offerFilter.downPaymentLabel, offer == null ? void 0 : offer.exampleDownPayment),
      tag: "p",
      disclaimerData: offer.disclaimerData
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _offerCard["default"].gridItem
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _offerCard["default"].gridSubtitle
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: offerLabel == null ? void 0 : offerLabel.monthsLabel,
      tag: "p",
      disclaimerData: offer.disclaimerData
    })))), (offerLabel == null ? void 0 : offerLabel.paymentCalcLabel) && ((0, _offersV2.isOfferType)(offer, 'finance') || (0, _offersV2.isOfferType)(offer, 'lease')) && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      spanClasses: [_offerCard["default"].paymentCalcBtn],
      data: {
        // priority: 'low',
        label: offerLabel == null ? void 0 : offerLabel.paymentCalcLabel,
        url: offer == null ? void 0 : offer.paymentApiUrl,
        ctaProps: {
          'data-analytics-offer-code': offer.offerCode,
          'data-vehicle-name': vehicleName
        }
      }
    })), (descriptionsMap == null || (_descriptionsMap$subH = descriptionsMap.subHeadline1) == null ? void 0 : _descriptionsMap$subH.text) && offer.disclaimerData && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: descriptionsMap.subHeadline1.text,
      className: theme.headingFour + " " + _offerCard["default"].subHeadlineOne,
      tag: "p",
      disclaimerData: offer.disclaimerData
    }), (offer == null ? void 0 : offer.subHeadlineTextTwo) && offer.disclaimerData && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: offer.subHeadlineTextTwo,
      className: theme.headingFive + " " + _offerCard["default"].subHeadlineTwo,
      tag: "p",
      disclaimerData: offer.disclaimerData
    }), (offer == null ? void 0 : offer.offerValid) && /*#__PURE__*/_react["default"].createElement("p", {
      className: "" + _offerCard["default"].offerExpiry
    }, offer.offerValid)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _offerCard["default"].ctaWrapper
    }, showActionButton && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      spanClasses: [_offerCard["default"].ctaBtn],
      data: {
        priority: 'critical',
        label: buildAndPriceUrl == null ? void 0 : buildAndPriceUrl.label,
        url: buildAndPriceUrl == null ? void 0 : buildAndPriceUrl.url,
        ctaProps: {
          'data-analytics-offer-code': offer.offerCode,
          'data-vehicle-name': vehicleName
        }
      }
    }), isInventoryBtnAvailable && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      spanClasses: [_offerCard["default"].ctaBtn],
      data: {
        priority: 'medium',
        label: offerLabel == null ? void 0 : offerLabel.inventoryLabel,
        url: "" + (offerLabel == null ? void 0 : offerLabel.inventoryRedirectionURL) + (offer == null ? void 0 : offer.inventorySuffixReqParam),
        openNewTab: true,
        ctaProps: {
          'data-analytics-offer-code': offer.offerCode,
          'data-vehicle-name': vehicleName
        }
      }
    })));
  };
  return OfferCard;
}(_react["default"].PureComponent);
OfferCard.displayName = 'OfferCard';